export default __webpack_public_path__ + "static/media/farm_animal.6c56cf4d.svg";